import { Divider, Stack } from '@mui/material';
import { FlowPatientDataStoreEndpoint } from 'flow-schema';

import { Text, type api, isDefined } from 'common';

import { PatientDataStoreVariants } from './Variants';
import {
  BlockSelectField,
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

type PatientDataStoreBlockConfig = api.FlowDefinition.PatientDataStore.PatientDataStoreBlockConfig;

const PDS_ENDPOINTS = Object.values(FlowPatientDataStoreEndpoint);

export function PatientDataStoreFormFields() {
  const { value: endpoint } =
    useSelectedNodeField<PatientDataStoreBlockConfig['endpoint']>('config.endpoint');
  const { Config } = isDefined(endpoint) ? PatientDataStoreVariants[endpoint] : { Config: null };
  return (
    <>
      <Stack gap={2}>
        <Text variant="heading5" bold>
          Patient
        </Text>
        <ParentBlockSelectField
          fieldName="config.patient.sourceBlockName"
          label="Patient Source"
          required
          helperText={getSourceBlockNameHelperText('patient')}
        />
      </Stack>
      <Stack gap={2}>
        <BlockSelectField
          label="Patient Data Store Endpoint"
          fieldName="config.endpoint"
          required
          options={PDS_ENDPOINTS.sort().map((endpoint) => ({
            label: endpoint,
            value: endpoint,
          }))}
        />
      </Stack>
      <Divider />
      <Stack gap={3}>{Config && <Config />}</Stack>
    </>
  );
}
